<template>
  <div class="support-4iQ">
    <Snackbar
        v-if="showSnackbar"
        :snackbarColor="snackbarColor"
        :snackbarMessage="snackbarMessage"
        @close="closeSnackbar()"
    >
    </Snackbar>
    <v-app class="support-4iq-form">
      <v-card v-model="showSupport4iQPopup" max-width=600 class="mx-auto">
        <v-form v-on:submit.prevent v-model="valid">
          <div class="user_creation_popup_div">
            <v-card-title class="pb-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <span class="headline indigo--text">4iQ support</span>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <p>Thank you for contacting 4iQ Support!</p>
                    <p>Please let us know how we can help you by providing us some details on the issue or question you have.</p>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="email"
                      id="supportEmail"
                      label="Email Address*"
                      :rules="[rules.required,rules.validDetails, rules.validEmail]"
                      v-on:keydown.enter.prevent
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="name"
                      id="supportName"
                      label="Name*"
                      :rules="[rules.required,rules.validDetails]"
                      v-on:keydown.enter.prevent
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="phone"
                      id="supportPhone"
                      label="Phone"
                      :rules="[rules.mobilemin]"
                      v-on:keydown.enter.prevent
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      v-model="message"
                      id="supportMessage"
                      label="Message*"
                      no-resize
                      rows="5"
                      :rules="[rules.required,rules.validDetails]"
                      v-on:keydown.enter.prevent
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 v-if="getSupport4iqLocation && captchaSiteKey">
                    <vue-recaptcha
                      ref="recaptcha"
                      class="vueRecaptcha"
                      @verify="onCaptchaVerified"
                      @expired="onCaptchaExpired"
                      :sitekey= "captchaSiteKey"> 
                    </vue-recaptcha>
                  </v-flex>
                  <!-- <span class="successMessage pa-2" v-show="errorMessage">Something went wrong, Please try again</span>
                  <span class="successMessage pa-2" v-show="successMessage">Password changed successfully!</span>-->
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :class="valid && (getSupport4iqLocation ? storeCaptchaToken != null : true )? '':'disabled'"
                depressed
                color="grey lighten-3"
                :tabindex="valid && (getSupport4iqLocation ? storeCaptchaToken != null : true )? '' : -1"
                type="submit"
                id="submitForm"
                @click="submit4iqSupportForm()"
              >Submit</v-btn>
              <v-btn depressed color="grey lighten-3" @click="closePopup();" id="cancelForm">cancel</v-btn>
            </v-card-actions>
          </div>
        </v-form>
      </v-card>
    </v-app>
  </div>
</template>
<script>
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import Snackbar from "./snackbar"
import VueRecaptcha from 'vue-recaptcha';
Vue.use(Vuetify);
require('../assets/scss/support4iQ.scss');

export default {
  name: "support4iQ",
  data() {
    return {
      showSupport4iQPopup: true,
      valid: false,
      rules: {
        required: value => !!value || "Required.",
        validDetails: v => v == null ? false : v.charAt(0) != ' ' || 'No spaces are allowed',
        validEmail: v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,20})+$/.test(v) || "Not a Valid Email",
        mobilemin: v => /^[\d\s]*$/.test(v) && v.length < 20 && v.charAt(0) != ' ' || "Not a valid Mobile Number"
      },
      email: null,
      name: null,
      phone: '',
      message: null,
      showSnackbar: false,
      snackbarColor: null,
      snackbarMessage: null,
      captchaSiteKey:'',
      storeCaptchaToken:null,
      getSupport4iqLocation: window.location.href.includes('support4iQ')
    };
  },
  components: {
      Snackbar,
      'vue-recaptcha': VueRecaptcha,
  },
  created(){
    if(this.getSupport4iqLocation){
      this.getSiteKey();
    }
  },
  methods: {
    getSiteKey(){
      var self = this;
      Vue.http.get("/captcha/site_key")
      .then((res) => {
          self.captchaSiteKey = res.data ? JSON.parse(res.data)['site_key'] : '';
      }, (error) => {
          console.log("let's display error message");
      });
    },
    onCaptchaVerified(response){
      var self = this;
      self.storeCaptchaToken = response;
    },
    onCaptchaExpired(){
      var self = this;
      self.$refs.recaptcha.reset();
    },
    submit4iqSupportForm() {
      var self = this; self.valid = false;
      let formData = new FormData();
      formData.append('email',self.email.trim());
      formData.append('name',self.name.trim());
      formData.append('phone_number',self.phone);
      formData.append('description',self.message.trim());
      formData.append('g-recaptcha-response',self.storeCaptchaToken)
      Vue.http.post('/contact4iq/',formData)
      .then((res) => {
        self.displaySnackbar('success-banner',res.data.message ? res.data.message : 'Email sent successfully');
        setTimeout(function(){
            self.closePopup();
        },1000)
      }
      ,(error)=>{
          self.displaySnackbar('error-banner',error.data.message ? error.data.message : 'Something went wrong');
      })
      if(self.getSupport4iqLocation){
        self.$refs.recaptcha.reset();
      }
    },
    displaySnackbar(color,message){
      var self = this;
      self.showSnackbar = false;
      setTimeout(function(){
          self.showSnackbar = true;
      },100)
      self.snackbarColor = color;
      self.snackbarMessage = message;
    },
    closeSnackbar(){
      var self = this;
      self.showSnackbar = false;
      self.snackbarColor = null;
      self.snackbarMessage = null;
    },
    closePopup() {
      var self = this;
      if(self.getSupport4iqLocation){
        self.$refs.recaptcha.reset;
        window.location = '/login.html#/';
      } else {
        self.$emit('close');
      }
    }
  }
};
</script>